import ErrorOutlineOutlined from '@mui/icons-material/ErrorOutlineOutlined';
import ScheduleOutlined from '@mui/icons-material/ScheduleOutlined';
import WarningAmberOutlined from '@mui/icons-material/WarningAmberOutlined';

/** The three severity slots the design shows, most severe first. */
export type AlarmSeverity = 'highest' | 'high' | 'medium';

export const ALARM_SEVERITIES: AlarmSeverity[] = ['highest', 'high', 'medium'];

export interface AlarmsToTriageSegment {
  severity: AlarmSeverity;
  count: number;
  /** The client's own criticality label -- never hardcode these. */
  label: string;
}

/*
 * Figma draws these as mdi:alert-outline, mdi:alert-circle-outline and
 * mdi:clock-alert-outline. The first two map cleanly onto MUI's outlined set;
 * MUI has no clock-with-exclamation, so the plain outlined clock stands in --
 * it still reads as the least urgent of the three.
 */
export const SEVERITY_ICON = {
  highest: WarningAmberOutlined,
  high: ErrorOutlineOutlined,
  medium: ScheduleOutlined,
};

export const SEVERITY_STYLE: Record<AlarmSeverity, { bar: string; icon: string }> = {
  highest: { bar: 'ds-bg-severity-highest', icon: 'ds-text-severity-highest' },
  high: { bar: 'ds-bg-severity-high', icon: 'ds-text-severity-high' },
  medium: { bar: 'ds-bg-severity-medium', icon: 'ds-text-severity-medium' },
};
